import React, { useContext } from "react";
import { QuestionContext } from "../../context";
import { QuestionContent } from "../QuestionContent";
import { Options } from "../Options";
import classNames from "classnames";

export function QuestionSingleChoice({
    className,
    children,
    style
}: RenderComponent) {
    const ctx = useContext(QuestionContext);
    if (ctx.type !== "SingleChoice") throw new Error("error type data");

    return (
        <div
            className={classNames("QuestionSingleChoice", className)}
            style={style}>
            <QuestionContent />
            <Options />

            {children}
        </div>
    );
}
